import * as React from "react";
function CheckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 21a.375.375 0 01-.265-.11L3.11 16.015a.375.375 0 01.53-.53l4.563 4.562L20.32 3.156a.378.378 0 01.523-.086.372.372 0 01.152.244.372.372 0 01-.065.28L8.554 20.844A.376.376 0 018.28 21h-.03z"
  }));
}
const ForwardRef = React.forwardRef(CheckIcon);
export default ForwardRef;